import { Component, OnInit, Input, Inject, ViewChild, Output, EventEmitter } from '@angular/core';
import { ReusableClasses } from '../reusableclassesAndFunctions/reusable-classes';
import { EncryptionService } from '../../encryption/encryption.service';
import * as jwt_decode from 'jwt-decode';
import { StatusConstant } from '../status/status-constant';
import { FormGroup, Validators, FormBuilder, FormControl } from '@angular/forms';
import { CoreService } from 'src/app/applicationModules/core/services/coreService/core.service';
import { SettingService } from 'src/app/applicationModules/settings/services/settingService/setting.service';
import { ToastrService } from 'ngx-toastr';
import { MatDialogRef, MatDialog, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { DatePipe } from '@angular/common';
import { LoaderService } from '../../shared/loader/loader.service';
import { Observable } from 'rxjs';


export interface State {
  name: string;
  fax: string;
  role: string;
  pic: string;
}

@Component({
  selector: 'app-addemail',
  templateUrl: './addemail.component.html',
  styleUrls: ['./addemail.component.scss']
})

export class AddEmailComponent implements OnInit {

  organizationId: string;
  databaseId: string;
  currentUser: any;
  responseHolder: any;

  folderId: number = 0;
  getTagListResponseHolder: any;
  formDialog: FormGroup;

  OfficeIDList: any = [];
  myOfficeID: any;
  spinner: boolean = false;


  @Output() closeShareFile3c = new EventEmitter<boolean>();
  menuModulesList: any = [] = [];
  folderID: number = 0;

  CorefolderID: number = 0;
  ContactfolderID: number = 0;
  CompanyfolderID: number = 0;
  roleIdList: any = [];
  showAddButton = false;
  timeout = null;
  selectedCoreId: number = 0;
  selectedContactId: number = 0;
  selectedCompanyId: number = 0;
  textNameShow: string = "Email";
  moduleFrom: string = "";
  addUpdateParticipantList: any = [] = [];
  stateCtrl = new FormControl();
  filteredStates: Observable<State[]>;
  emailAssigned: string = '';
  addEmailButtonShow: boolean = false;
  typeofParticipantList: any = [] = [];

  constructor(private dialog: MatDialog, private dialog1: MatDialog, private datePipe: DatePipe, public dialogRef: MatDialogRef<AddEmailComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any, private formBuilder: FormBuilder, private encryptionAlgo: EncryptionService,
    private reusableClass: ReusableClasses, private settingsService: SettingService, private statusConst: StatusConstant,
    private coreService: CoreService, private toastr: ToastrService, private loaderService: LoaderService,) {

    const encryptedtoken = sessionStorage.getItem('userToken');
    this.databaseId = sessionStorage.getItem('databaseId')?? '';
     this.organizationId = sessionStorage.getItem('organizationID')?? '';
    if (encryptedtoken != null) {
      const token = this.encryptionAlgo.get(this.reusableClass.encryptionKey, encryptedtoken);
      this.currentUser = jwt_decode(token);
      var offices = JSON.parse(sessionStorage.getItem('officeList'));
      offices.forEach(oe => {
        this.OfficeIDList.push(oe.officeID);
        if (oe.isMyoffice == true)
          this.myOfficeID = oe.officeID;
      });
    }
  }

  ngOnInit(): void {
    if (this.data) {
      this.showAddButton = true;
      this.menuModulesList = JSON.parse(sessionStorage.getItem("menuModules"));
      this.moduleFrom = this.data.moduleName;

      if (this.data.emails) {
        let emailList = this.data.emails.split(',');
        emailList.forEach((email: string) => {
          email = email.trim();
          if (email !== "") {
            let toArray = email.split("@");
            let shortName = toArray[0].match(/\b(\w)/g)?.join('') || '';
            var obj = {
              name: "",
              email: email,
              img: "",
              shortName: shortName
            };
            this.addUpdateParticipantList.push(obj);
          }
        });

        // Reset input
        this.emailAssigned = "";
        this.addEmailButtonShow = false;
        if (this.addUpdateParticipantList.length > 0) {
          this.showAddButton = false;
        } else {
          this.showAddButton = true;
        }
      }
    }

  }


  removeParticipant(item: any) {
    const index = this.addUpdateParticipantList.indexOf(item);
    if (index >= 0) {
      this.addUpdateParticipantList.splice(index, 1);
    }
    if (this.addUpdateParticipantList.length > 0) {
      this.showAddButton = false;
    } else {
      this.showAddButton = true;
    }
  }


  //==== For Add Email================//

  addEmail() {
    // if (this.addUpdateParticipantList.length > 0) {
    //    this.stateCtrl.setValue('');
    //    this.toastr.warning('Only one record is allowed.', '', {
    //     timeOut: 3000,
    //   });
    //   return;
    // }
    var check = [];
    check = this.addUpdateParticipantList.filter((x:any) => x.email.toLowerCase() == this.emailAssigned.toLowerCase())

    let toArray = this.emailAssigned.split("@");
    var shortName = toArray[0].match(/\b(\w)/g).join('');
    if (check.length == 0) {
      var obj = {
        name: "",
        email: this.emailAssigned,
        img: "",
        shortName: shortName
      }
      this.addUpdateParticipantList.push(obj);
      this.emailAssigned = "";
      this.addEmailButtonShow = false;
      if (this.addUpdateParticipantList.length > 0) {
        this.showAddButton = false;
      } else {
        this.showAddButton = true;
      }
    } else {
      this.emailAssigned = "";
      this.addEmailButtonShow = false;
      this.toastr.warning('Email allready added.', '', {
        timeOut: 3000,
      });
    }
  }

  emailCheck(searchValue: any) {
    if (searchValue.toLowerCase() == searchValue.toLowerCase().match('^[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,4}$')) {
      this.emailAssigned = searchValue;
      this.addEmailButtonShow = true;
    } else {
      this.addEmailButtonShow = false;
    }
  }

  assignTasklistToEmails() {
    this.dialogRef.close(this.addUpdateParticipantList);
  }

  close() {
    this.dialogRef.close();
  }

}
